
window.runtime = {
  // 运行环境 development ｜ production
  // @ts-expect-error: webpack 注入数据，不使用node上下文
  env: process.env,
  // 运行版本
  version: process.version,
};
